/** @prettier */

/* eslint-disable indent-legacy */
import PropTypes from 'prop-types';
import React from 'react';

import IconAlert from '../../../../../assets/images/icons/misc/icon-alert.svg';

import style from './Unavailable.module.scss';

const Unavailable = ({ children }) => (
  <div className={style.main}>
    <IconAlert />
    {children}
  </div>
);

Unavailable.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Unavailable;
